import { useCallback, useMemo } from 'react';
import uPlot from 'uplot';
import { UPlotChart } from '../twin/ui/components/UPlotChart';
import { axisDefaults, useChartColours } from '../twin/ui/components/chartTheme';
import type { SeriesPoint } from '../twin/ui/lib/graphSeries';

/** Measured points only: gaps remain gaps, without extrapolation or confidence bands. */
export function MeasuredGraph({ points, unit, days, discrete=false }: { points: SeriesPoint[]; unit: string; days: number; discrete?:boolean }) {
  const colours = useChartColours();
  const data = useMemo<uPlot.AlignedData>(() => {
    const x: number[] = [], y: Array<number | null> = [];
    const windowMs = (days <= 2 ? 5 : days <= 7 ? 30 : days <= 31 ? 120 : 360) * 60_000;
    points.forEach((p, i) => {
      if (i && p.t - points[i - 1].t > windowMs * 1.5) { x.push((points[i - 1].t + windowMs) / 1000); y.push(null); }
      x.push(p.t / 1000); y.push(p.v);
    });
    return [x, y];
  }, [points, days]);
  const options = useCallback((): Omit<uPlot.Options, 'width' | 'height'> => ({
    tzDate: timestamp => uPlot.tzDate(new Date(timestamp * 1000), 'UTC'),
    scales: { x: { time: true } },
    series: [{ label: 'UTC', value: (_u, value) => value == null ? '' : new Date(value * 1000).toISOString() },
      { label: unit || 'Measured', stroke: colours.live, width: 1.5, spanGaps: false, paths:discrete?uPlot.paths.stepped?.({align:1}):undefined, points: { show: points.length < 100 } }],
    axes: [axisDefaults(colours), axisDefaults(colours)], legend: { show: true },
  }), [colours, unit, points.length,discrete]);
  if (!points.length) return <p className="p-3 text-ink-3">No measured history in this range.</p>;
  return <><UPlotChart data={data} buildOptions={options} height={260} className="mb-12" /><p className="text-[10px] text-ink-3">Measured history is aggregated into time windows; gaps are not filled. No forecast is drawn.</p></>;
}
